// extracted by mini-css-extract-plugin
export default {"container":"PaymentMethod_container__t-50e","title":"PaymentMethod_title__S1UI2","label":"PaymentMethod_label__uKjnb","value":"PaymentMethod_value__NMQvO"};